<template>
  <b-dropdown
	id="dropdown-1"
	size="sm"
	:text="'Carrito ('+(_newTrasnpServices.length+_newAdditionalServices.length)+')'"
	variant="outline-primary"
	ref="dropDownCart"
	menu-class="scrollDropdown"
	@show="showed"
	class="px-2">

		<div class="u:dropdown-body">
			<b-dropdown-form class="shadow" v-if="_priceCartTotal >0">
				<div class="d-flex flex-column w-100">
					<div class="w-100" v-if="_newTrasnpServices.length>0">
						<!-- transportes nuevos-->
						<div class="w-100 row no-gutters text-primary ">
							<div class="col-8 u:text-size-2 d-flex">
								<h6 class="mr-2">({{_newTrasnpServices.length}})</h6>
								<h6 class="mr-5">Transporte</h6>
							</div>
							<div class="col-4 text-right" @click="deleteTransportService()">
								<md-icon class="text-primary u:cursor-pointer" icon="delete" />
							</div>
						</div>
						<div class="w-100 row no-gutters">
							<div class="col-12 u:text-size-3 text-primary">{{propRateSelected.serviceType.name}}</div>
							<div class="col-8 u:text-size-2">Hasta {{propRateSelected.serviceType.maxPax}} pax</div>
							<div class="col-8 u:text-size-2">{{propRateSelected.serviceType.maxSuitecase}} Maleta</div>
							<div class="col-8 u:text-size-2" v-if="propRateSelected.meetAndGreet">Meet&Greet</div>

							<div class="d-flex u:text-size-2 single-line">
								<div>{{propRoundTrip?'Viaje redondo':'Viaje sencillo'}}</div>
								<div class="flex-grow-1 ml-4 text-right font-weight-bold u:text-uppercase"><label class="u:text-size-1">{{this.propRateSelected.currency+"$ "}}</label> {{(this.propRoundTrip? this.propRateSelected.roundtrip: this.propRateSelected.oneway)}}</div>
							</div>
							<!-- <div class="col-4 u:text-size-2 font-weight-bold text-right">{{propRoundTrip?propRateSelected.bookInfoPrice*2: propRateSelected.oneway}}</div> -->
						</div>
					</div>

					<!-- servicios adicionales con transportes -->

					<div class="mt-4 w-100 row no-gutters" v-if="_newAdditionalServices.length > 0">
						<div class="col-8 u:text-size-2 d-flex text-primary ">
							<h6 class="mr-2">({{_newAdditionalServices.length}})</h6>
							<h6 class="mr-5">Adicionales</h6>
						</div>
						<div class="col-4 text-right" @click="deleteAdditionalServices()">
							<md-icon class="text-primary u:cursor-pointer" icon="delete" />
						</div>
					</div>


					<div class="w-100 row no-gutters u:hover:bg-white-2 py-2"
						v-for="(itemAddtService, indexAS) in _newAdditionalServices" :key="indexAS">
							<div class="w-100 " v-for="(itemRate, indexRate) in itemAddtService.rates" :key="indexRate">
							<div class="w-100" v-if="itemRate.quantity>0">
								<div class="u:h-fit-content d-flex u:text-size-2 single-line" v-if="indexRate==0">
									<strong class="mr-1" v-if="'transportServiceReference' in itemAddtService.related">#{{itemAddtService.related.transportServiceReference.slice(5)}}: </strong>
									<strong class="mr-1" v-else>#Reserva: </strong>
									{{itemAddtService.name}}

									<div class="flex-grow-1 text-right ml-4" @click="deleteAdditionalService(itemAddtService)">
										<md-icon class="u:cursor-pointer" icon="delete" />
									</div>
								</div>

								<div class="u:h-fit-content d-flex u:text-size-2" v-if="!itemAddtService.quote.specialRate">
									<label class="m-0 text-capitalize">{{itemRate.quantity+" "+itemRate.category}}</label>
									<label class="m-0 flex-grow-1 ml-4 text-right font-weight-bold text-uppercase"><span class=" text-uppercase">{{itemAddtService.currency+"$ "}}</span> {{itemRate.price*itemRate.quantity}}</label>
								</div>
							</div>
						</div>
						<div v-if="itemAddtService.quote.specialRate" class="w-100 mt-1 d-flex justify-content-between u:text-size-2">
							<span>Precio especial <small>({{itemAddtService.quote.specialRateData.reason}})</small></span>
							<b><span class=" text-uppercase">{{itemAddtService.currency+"$ "}}</span> {{itemAddtService.quote.bookingPriceTotal}}</b>
						</div>
					</div>

					<!-- servicios adicionales para la reserva -->
				</div>

			</b-dropdown-form>
			<b-dropdown-form v-else class="shadow">
				<h6 class="text-primary mx-5 d-flex">
					<span>Carrito</span>
					<span class="ml-1">vacio</span>
				</h6>
				<p class="text-center u:text-size-2">Aun no seleccionaste ningun servicio de transporte</p>
			</b-dropdown-form>
		</div>
		<!-- Footer del carrito: total y fecha -->
		<div class="w-100 px-4 py-2" v-if="_priceCartTotal >0">
			<hr class="bg-primary">
			<div class="w-100 row no-gutters">
				<div class="col-5 text-primary font-weight-bold">Total</div>
				<div class="col-7 text-primary font-weight-bold text-right">{{this.propRateSelected.currency}}$ {{_priceCartTotal.toFixed(2)}}</div>
			</div>

			<div class="w-100 d-flex mt-2 single-line">
				<div class="u:text-size-2 mr-4 u:text-dark-3">Agregar pago automático</div>
				<div class="flex-grow-1 u:text-size-2 d-flex align-items-center justify-content-end">
					<input disabled type="checkbox" checked>
				</div>
			</div>

			<div class="w-100 d-flex mt-2 single-line">
				<div class="u:text-size-2 mr-4">Vencimiento link de pago</div>
				<div class="flex-grow-1 text-right u:text-size-2">
					<input type="date" v-model="dateField">
					<input type="time" v-model="timeField">
				</div>
			</div>

			<b-button class="w-100 mt-2" size="sm" variant="success" @click="bookCart()">BOOK</b-button>
		</div>

	</b-dropdown>
</template>

<script>

export default {
	props:{
		propViewModel:Object,
		propRateSelected:Object,
		propRoundTrip:Boolean,
	},
	data(){
		return{
			dateField:"",
			timeField:""
		}
	},
	computed:{
		_priceCartTotal(){
			let total=0;
			//obtenemos el total de addtSetvices
			this._newAdditionalServices.forEach(itemAddtService => {
				total = total + itemAddtService.quote.bookingPriceTotal
			});
			//rateSelected no es vacio?
			if(Object.keys(this.propRateSelected).length != 0){
				//obtenemos el total del trasnpService
				total+=this.propRoundTrip? parseFloat(this.propRateSelected.roundtrip): parseFloat(this.propRateSelected.oneway);
			}
			return total;
		},
		_oldTranspServices(){
			return this.propViewModel.transportServices.filter(item=>{
				return item.status == "active" || item.status == "pending";//??TS
			})
		},
		_newTrasnpServices(){
			return this.propViewModel.transportServices.filter(item=>{
				return item.id==-1;//??TS
			})
		},
		_newAdditionalServices(){
			return this.propViewModel.additionalServices.filter(item=>{
				return item.id==-1;
			})
		},
		_newAdditionalServicesWithCount(){
			return this.propViewModel.additionalServices.filter(item=>{
				return item.id==-1;
			})
		},
		_oldAdditionalServices(){
			return this.propViewModel.additionalServices.filter(item=>{
				return item.id != -1;
			})
		},

	},
	watch:{
	},
	mounted(){
	},
	methods:{

		showed(){
			if('paymentInfo' in this.propViewModel){
				this.dateField = this.propViewModel.paymentInfo.date;
				this.timeField = this.propViewModel.paymentInfo.time;
			}
		},
		bookCart(){
			this.$emit('bookCart', { date: this.dateField, time:this.timeField, cost:this._priceCartTotal});
		},
		deleteTransportService(){
			//escondemos el dropDown
			this.$refs.dropDownCart.hide();
			//ejecutamos el evento de eliminar los utimos transport services nuevo
			this.$emit('deleteTransportService');
		},
		deleteAdditionalServices(){
			//escondemos el dropDown
			this.$refs.dropDownCart.hide();
			//ejecutamos el evento de eliminar los utimos transport services nuevo
			this.$emit('deleteAdditionalServices');
		},
		deleteAdditionalService(index){
			//escondemos el dropDown
			this.$refs.dropDownCart.hide();
			//ejecutamos el evento de eliminar los utimos transport services nuevo
			// this.$emit('deleteAdditionalService', (index + this._oldAdditionalServices.length));
			this.$emit('deleteAdditionalService', (index));
		}

	}
}
</script>

<style scoped>
.single-line {
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.u\:dropdown-body {
    max-height: 280px!important;
    overflow-y: auto!important;
}

.u\:text-uppercase{
	text-transform: uppercase;
}
.u\:text-capitalize{
	text-transform: capitalize;
}
</style>
